module.exports = __webpack_public_path__ + "img/DE01109.06414948.png";